import React from 'react';
import {
  Typography,
  Box,
  Button,
  Alert
} from '@mui/material';
import { ArrowBack, CheckCircle } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import RecordingControls from './RecordingControls';

const LiveRecording = () => {
  const navigate = useNavigate();
  const [success, setSuccess] = React.useState('');
  const [error, setError] = React.useState('');

  React.useEffect(() => {
    document.title = 'Live Recording - EchoNote';
  }, []);

  const handleRecordingComplete = (data) => {
    setSuccess('Recording saved successfully! The transcription will be processed shortly.');
    setError('');
    
    // Redirect to meeting detail after a short delay
    if (data.meeting) {
      setTimeout(() => {
        navigate(`/meeting/${data.meeting.id}`);
      }, 2000);
    }
  };

  const handleError = (errorMessage) => {
    setError(errorMessage);
    setSuccess('');
  };

  return (
    <Box>
      <Box display="flex" alignItems="center" mb={3}>
        <Button
          startIcon={<ArrowBack />}
          onClick={() => navigate('/dashboard')}
          sx={{ mr: 2 }}
        >
          Back to Dashboard
        </Button>
        <Typography variant="h4">
          Live Recording
        </Typography>
      </Box>

      {success && (
        <Alert severity="success" icon={<CheckCircle />} sx={{ mb: 3 }}>
          {success}
        </Alert>
      )}

      {error && (
        <Alert severity="error" onClose={() => setError('')} sx={{ mb: 3 }}>
          {error}
        </Alert>
      )}

      <RecordingControls
        onRecordingComplete={handleRecordingComplete}
        onError={handleError}
      />

      <Box sx={{ mt: 3 }}>
        <Typography variant="h6" gutterBottom>
          How it works:
        </Typography>
        <Typography variant="body2" component="div" color="text.secondary">
          <ol>
            <li>Click "Start Recording" to begin</li>
            <li>Accept the consent dialog to continue</li>
            <li>Grant microphone permissions when prompted by your browser</li>
            <li>Speak into your microphone - your audio will be captured</li>
            <li>Click "Stop Recording" when finished</li>
            <li>Your recording will be saved and automatically transcribed</li>
          </ol>
        </Typography>
      </Box>
    </Box>
  );
};

export default LiveRecording;
